import { useLocalStorageValue, useSessionStorageValue } from "@react-hookz/web";
import { useCallback, useMemo } from "react";
export const useFallbackStorageValue = (key, options) => {
  const {
    fetch: LocalStorageFetch,
    remove: localStorageRemove,
    set: localStorageSet,
    value: localStorageValue
  } = useLocalStorageValue(key, options);
  const {
    fetch: sessionStorageFetch,
    remove: sessionStorageRemove,
    set: sessionStorageSet,
    value: sessionStorageValue
  } = useSessionStorageValue(key, options);
  const handleSet = useCallback(parameter => {
    try {
      localStorageSet(parameter);
    } catch {
      sessionStorageSet(parameter);
    }
  }, [localStorageSet, sessionStorageSet]);
  const handleFetch = useCallback(() => {
    LocalStorageFetch();
    sessionStorageFetch();
  }, [LocalStorageFetch, sessionStorageFetch]);
  const handleRemove = useCallback(() => {
    localStorageRemove();
    sessionStorageRemove();
  }, [localStorageRemove, sessionStorageRemove]);
  const wrappedValue = useMemo(() => localStorageValue !== null && localStorageValue !== void 0 ? localStorageValue : sessionStorageValue, [localStorageValue, sessionStorageValue]);
  return {
    fetch: handleFetch,
    remove: handleRemove,
    set: handleSet,
    value: wrappedValue
  };
};